interface VisualSearchResultState {
  enableGrayScale?: boolean;
  imageLoaded: boolean;
  imageSrc: string;
  imageData: Uint8Array;
  luminanceSearch: boolean;
}

export default VisualSearchResultState;

export const initialState: VisualSearchResultState = {
  enableGrayScale: false,
  imageLoaded: false,
  imageSrc: '',
  imageData: null,
  luminanceSearch: true,
};
